import React from 'react';
import cx from 'classnames';
import { string, node, bool, oneOf, func } from 'prop-types';
import segmentStatus from 'propTypes/segmentStatus';

import styles from './ListItem.scss';

const ListItem = ({
  id,
  className,
  children,
  isActive,
  status,
  contentType,
  onClick,
  onMouseOver,
  onMouseOut,
}) =>
  <li
    className={cx(styles.main, className, styles[`status-${status}`], {
      [styles.isActive]: isActive,
      [styles.location]: contentType === 'location',
      [styles.segment]: contentType === 'segment',
      [styles.route]: contentType === 'route',
    })}
  >
    <a
      className={styles.link}
      href={`/map/live/${contentType}s/${id}`}
      onClick={evt => {
        evt.preventDefault();
        onClick();
      }}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      {children}
    </a>
  </li>;

ListItem.propTypes = {
  id: string.isRequired,
  className: string,
  contentType: oneOf(['segment', 'location', 'route']),
  children: node,
  isActive: bool,
  status: segmentStatus.isRequired,
  onClick: func.isRequired,
  onMouseOver: func.isRequired,
  onMouseOut: func.isRequired,
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/DataPanel/Overview/ListItem/index.js